import { ALL_TRADES_LIST, ALL_TRADES_LIST_SUCCESS, ALL_TRADES_LIST_FAILURE } from "../actionTypes";

export const getAllTradesList = (payload) => ({
  type: ALL_TRADES_LIST,
  payload,
});

export const getAllTradesListSuccess = (payload) => ({
  type: ALL_TRADES_LIST_SUCCESS,
  payload,
});

export const getAllTradesListFailure = () => ({
  type: ALL_TRADES_LIST_FAILURE,
});